import { useEffect } from "react";
import { useIntercomLauncherVisibility } from "@/context/IntercomLauncherVisibilityContext";

const CLASS = "bilenia-native-media-viewer-open";

/**
 * While a portaled fullscreen image viewer is open, underlying sheets/dialogs
 * must not steal pointer events; hide Intercom launcher (web + native).
 */
export function useNativeMediaViewerOpen(open: boolean) {
  const { setSuppressIntercomLauncher } = useIntercomLauncherVisibility();

  useEffect(() => {
    if (!open) return;
    document.documentElement.classList.add(CLASS);
    setSuppressIntercomLauncher(true);
    return () => {
      document.documentElement.classList.remove(CLASS);
      setSuppressIntercomLauncher(false);
    };
  }, [open, setSuppressIntercomLauncher]);
}
